export const SET_OPPORTUNITIES = "SET_OPPORTUNITIES";
export const SET_SELECTED_OPPORTUNITIES = "SET_SELECTED_OPPORTUNITIES";
export const SET_OPPORTUNITIES_OPTIONS = "SET_OPPORTUNITIES_OPTIONS";
export const SET_TAXES = "SET_TAXES";
export const ADD_TAXES = "ADD_TAXES";
export const EDIT_TAXES = "EDIT_TAXES";
export const DELETE_TAXES = "DELETE_TAXES";
export const SET_WEIGHT_OPPORTUNITIES = "SET_WEIGHT_OPPORTUNITIES";
